import React, { useContext, useEffect, useState } from 'react';
import LoadingSpinner from '../../../common/LoadingSpinner';
import { Table } from 'react-bootstrap';
import OrderLineRow from './OrderLineRow';
import OrderContext from '../OrderContext';
import UserContext from '../../../user/UserContext';

export default function OrderLines({ imageUrl, imageAlt, upsoldFrom, products, loading, upsoldId}) {
    const [productRows, setProductRows] = useState([]);
    const { basket } = useContext(OrderContext);
    const { userDetails } = useContext(UserContext);

    useEffect(() => {
        setProductRows(
            products.map(product => (
                <OrderLineRow
                    product={product}
                    code={product.supplierProductCode}
                    key={product.supplierProductCode}
                    orderLine={
                        basket.items.filter(line => line.productCode === product.supplierProductCode)[0]
                    }
                    upsoldFrom={upsoldFrom}
                    upsoldId={upsoldId}
                />
            ))
        );
    }, [products, upsoldFrom, basket, upsoldId]);

    return (
        <div>
            {imageUrl && <img src={imageUrl} alt={imageAlt} className={'banner'} />}
            <Table className={'product-range-table'}>
                <thead>
                    <tr>
                        <th className={'image-column column-7'}>Image</th>
                        <th className={'column-7'}>Code</th>
                        <th>Description</th>
                        <th className={'column-9'}>Unit Size</th>
                        {userDetails.currentFranchise && userDetails.currentFranchise.rebates && (
                            <th className={'column-9'}>Best Cost</th>
                        )}
                        <th className={'column-9'}>Invoice Cost</th>
                        <th className={'column-7'}>RSP</th>
                        <th className={'column-7'}>Margin</th>
                        <th className={'centered column-7'}>Quantity</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={9}>
                                <LoadingSpinner />
                            </td>
                        </tr>
                    ) : (
                        productRows
                    )}
                </tbody>
            </Table>
        </div>
    );
}
